import React, {useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import {helpers} from "./helpers";
import {useForm} from "react-hook-form";
import {Button} from "@mui/material";
import useCaptcha from 'use-offline-captcha'
import Grid from "@mui/material/Grid";
import {useHistory} from "react-router-dom";
import {services} from "./services";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import LoadingButton from '@mui/lab/LoadingButton';
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SimpleRepairRequest = () => {
    let history = useHistory();
    const captchaRef = useRef()
    const userOpt = {
        type: 'mixed', // "mixed"(default) | "numeric" | "alpha"
        length: 5, // 4 to 8 number. default is 5
        sensitive: false, // Case sensitivity. default is false
        width: 140, // Canvas width. default is 200
        height: 52, // Canvas height. default is 50
        fontColor: '#4b4b4b',
        background: 'rgba(255, 255, 255, .2)'
    }
    const {gen, validate} = useCaptcha(captchaRef, userOpt)
    const [loading, setLoading] = React.useState(false);
    const [mobile, setMobile] = React.useState("");
    const {register, handleSubmit, formState: {errors}} = useForm();
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [snackBarMessage, setSnackBarMessage] = React.useState("");
    const [snackBarType, setSnackBarType] = React.useState("");

    function showSnackBar(type, message) {
        setSnackBarMessage(message);
        setSnackBarType(type);
        setOpenSnackBar(true);
    }

    const onSubmit = (data) => {
        // console.log(data);
        const isValid = validate(data.captcha)
        // console.log(isValid.toString());
        if (dataValidation(data)) {
            if (isValid) {
                setLoading(true);
                services.submitRequest(1,
                    helpers.toEnglishNumber(data.name),
                    helpers.toEnglishNumber(data.family),
                    helpers.toEnglishNumber(data.mobile),
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    helpers.toEnglishNumber(data.descriptions),
                    null,
                    null,
                    null,
                    null)
                    .then((response) => {
                        // console.log(response);
                        if (response.data[0].returnValue === 1) {
                            history.push("/success");
                            setLoading(false);
                        } else {
                            showSnackBar("error", "خطا در ثبت درخواست!!!");
                            setLoading(false);

                        }
                    });
            } else {
                showSnackBar("error", "کد امنیتی اشتباه است");
            }
        }
    }

    const dataValidation = (data) => {
        if (helpers.toEnglishNumber(data.mobile).substring(0, 2) !== '09') {
            showSnackBar("warning", "فرمت موبایل اشتباه است");
        } else if (helpers.toEnglishNumber(data.mobile).length !== 11) {
            showSnackBar("warning", "شماره موبایل اشتباه است");
        } else {
            return true;
        }
    }

    useEffect(() => {
        if (gen) gen()
    }, [gen])

    const handleRefresh = () => gen()

    const onMobileChange = (e) => {
        const onlyNums = e.replace(/[^0-9]/g, '');
        // if (onlyNums.length < 12) {
        setMobile(onlyNums);
        // console.log("Mobile", onlyNums);
        // }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    };

    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}>
                <CloseIcon fontSize="small"/>
            </IconButton>
        </React.Fragment>
    );

    return (
        <div style={{marginTop: '15px', textAlign: 'right'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <TextField
                    inputProps={{maxLength: 20}}
                    style={{margin: '0 8px 0 8px', width: '95%'}}
                    id="outlined-basic" label="نام" variant="filled"
                    {...register("name", {required: "نام خود را وارد نمایید."})}
                    error={Boolean(errors.name)}
                    helperText={errors.name?.message}/>

                <TextField
                    inputProps={{maxLength: 35}}
                    style={{margin: '12px 8px 0 8px', width: '95%'}}
                    id="outlined-basic" label="نام خانوادگی" variant="filled"
                    {...register("family", {required: "نام خانوادگی خود را وارد نمایید."})}
                    error={Boolean(errors.family)}
                    helperText={errors.family?.message}/>

                <TextField
                    inputProps={{maxLength: 11}}
                    value={helpers.toPersianNumber(mobile)}
                    style={{margin: '12px 8px 0 8px', width: '95%'}}
                    id="outlined-basic" label="شماره موبایل" variant="filled"
                    error={Boolean(errors.mobile)}
                    helperText={errors.mobile?.message}
                    {...register(
                        "mobile",
                        {
                            required: "شماره موبایل خود را وارد نمایید.",
                            onChange: (e) => onMobileChange(helpers.toEnglishNumber(e.target.value))
                        }
                    )}/>

                <TextField
                    inputProps={{maxLength: 250}}
                    style={{margin: '12px 8px 0 8px', width: '95%'}}
                    id="outlined-multiline-static"
                    label="توضیحات"
                    variant="filled"
                    multiline
                    rows={1}
                    {...register("descriptions")}/>

                <Grid container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      style={{marginTop: '25px'}}>

                    <Grid item>
                        <TextField
                            inputProps={{maxLength: 5}}
                            style={{width: '140px', marginLeft: '5px'}}
                            id="outlined-basic" label="کد امنیتی" variant="outlined"
                            {...register("captcha", {required: "کد امنیتی را وارد کنید."})}
                            error={Boolean(errors.captcha)}
                            // helperText={errors.captcha?.message}
                            helperText="کد روبرو را وارد کنید."/>
                    </Grid>

                    <Grid item>
                        <div style={{direction: "ltr", marginTop: '2px'}} ref={captchaRef}/>
                        <Button
                            style={{
                                textAlign: "center",
                                fontSize: "12px",
                                display: "block",
                                marginRight: "auto",
                                marginLeft: "auto",
                                padding: "0px",
                                color: "#D83030"
                            }}
                            onClick={handleRefresh}>تغییر کد</Button>
                    </Grid>
                </Grid>

                <LoadingButton
                    style={{
                        backgroundColor: '#D83030',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '20px',
                        display: 'flex',
                        padding: '13px 35px 13px 35px'
                    }}
                    type="submit"
                    size="medium"
                    endIcon={<KeyboardDoubleArrowLeft/>}
                    loading={loading}
                    loadingPosition="end"
                    variant="contained"
                >ثبت درخواست</LoadingButton>
            </form>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={openSnackBar}
                autoHideDuration={5000}
                onClose={handleClose}
                action={action}>
                <Alert onClose={handleClose} severity={snackBarType} sx={{width: '100%'}}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}